/*
    * Описание параметров:
        -- Selected_Workshop_IDs - ID цеха
        -- Selected_Field_IDs - ID месторождения
        -- Selected_Area_IDs - ID площади
        -- Selected_Mine_IDs - ID куста
*/

/*
    TODO: add description
*/

const map = {
    workshop: 'Selected_Workshop_IDs',
    field: 'Selected_Field_IDs',
    venture: 'Selected_Venture_ID',
    area: 'Selected_Area_IDs',
    pad: 'Selected_Mine_IDs',
};

const mapMer = {
    workshop: 'Selected_Workshop_IDs',
    fieldIds: 'Selected_Field_IDs',
    ventureId: 'Selected_Venture_ID',
    area: 'Selected_Area_IDs',
    pad: 'Selected_Mine_IDs',
    isElements: 'useGrouping',
};

const defaultParams = {
    workshop: 0,
    field: 0,
    area: 0,
    pad: 0,
};

const defaultMerParams = {
    workshop: 0,
    fieldIds: 0,
    ventureId: 0,
    area: 0,
    pad: 0,
    isElements: false,
};

/*
    Объединяет базовые параметры с переданными. Так как все выше перечисленные значения должны участвовать в запросе.
    TODO: необходим контракт, чтобы избежать ошибки передачи параметров в функцию.
*/
export const settingsInfoParams = (params = {}) => {
    return Object.entries(defaultParams).reduce((acc, param) => {
        const [name, value] = param;

        if (name in params) {
            return { ...acc, [map[name]]: params[name] };
        }

        return { ...acc, [map[name]]: value };
    }, {});
};

export const merParams = (params = {}) => {
    return Object.entries(defaultMerParams).reduce((acc, param) => {
        const [name, value] = param;

        if (name in params) {
            return { ...acc, [mapMer[name]]: params[name] };
        }

        return { ...acc, [mapMer[name]]: value };
    }, {});
};
